module.exports = __webpack_public_path__ + "media/images/new_home/black_Plus_Circle-6717a2a629406c9001f2fcbc3b76860f.png";